import { useAlert } from 'react-alert';
import { useTranslation } from 'react-i18next';

import { useActions } from '../../../../../hooks/useActions';
import { useModalDetails } from '../../../../../hooks/useModalDetails';
import { useProcessing } from '../../../../../hooks/useProcessing';
import { useCancellationToken } from '../../../../../hooks/useTokenCancellation';
import { updateModalState } from '../../../../../store/redux-slices/modals';
import { SECONDARY_MEMBER_DELETE_PROCESSING } from '../../../../../store/redux-slices/processes/constants';
import { deleteSecondarySRMember } from '../../../../../store/saga-slices/membership/securityResponse';
import { IDeleteSecondarySRMemberPayload } from '../../../../../store/saga-slices/membership/securityResponse/models';
import { DELETE_SR_FAMILY_MEMBER_MODAL_NAME } from './deleteSRFamilyMemberModal.const';
import { DeleteSRFamilyMemberModalDetails } from './deleteSRFamilyMemberModal.models';

type UseDeleteSRFamilyMemberModalProps = {
  onFamilyMemberRemoved?: () => void;
  id?: string;
};

export const useDeleteSRFamilyMemberModal = ({
  onFamilyMemberRemoved,
  id,
}: UseDeleteSRFamilyMemberModalProps = {}) => {
  const { t } = useTranslation();
  const alert = useAlert();

  const UpdateModalState = useActions(updateModalState);
  const DeleteSecondaryMember = useActions(deleteSecondarySRMember);

  const { member, membershipId }: DeleteSRFamilyMemberModalDetails =
    useModalDetails(DELETE_SR_FAMILY_MEMBER_MODAL_NAME + id);

  const cancellationToken = useCancellationToken();

  const isDeleting = useProcessing(SECONDARY_MEMBER_DELETE_PROCESSING);

  const name = `${member?.firstName} ${member?.lastName}`;

  const onBackHandler = () => {
    UpdateModalState(DELETE_SR_FAMILY_MEMBER_MODAL_NAME + id);
  };

  const deleteSecondaryMemberHandler = () => {
    const payload: IDeleteSecondarySRMemberPayload = {
      cancellationToken,
      memberId: member?.memberId,
      membershipId,
      success: () => {
        onFamilyMemberRemoved?.();
        alert.success(t('phrase.family-member-deleted-success'));
        UpdateModalState(DELETE_SR_FAMILY_MEMBER_MODAL_NAME + id);
      },
      error: () => {
        alert.error(t('phrase.family-member-deleted-fail'));
      },
    };

    DeleteSecondaryMember(payload);
  };

  return {
    onBackHandler,
    name,
    deleteSecondaryMemberHandler,
    isDeleting,
  };
};
